import firebase from 'firebase'

const firebaseConfig = {
  apiKey: "AIzaSyB8W1fSoaykzcMZCBYZAgGiC0SoVFTncn8",
  authDomain: "tinder-clone-88339.firebaseapp.com",
  databaseURL: "https://tinder-clone-88339.firebaseio.com",
  projectId: "tinder-clone-88339",
  storageBucket: "tinder-clone-88339.appspot.com",
  messagingSenderId: "1076946010893",
  appId: "1:1076946010893:web:e54a7588d72675da612644",
  measurementId: "G-8FVH47GZWQ"
};

const firebaseApp = firebase.initializeApp(firebaseConfig)
const database = firebaseApp.firestore()

export default database